import React, { useContext } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import UserContext from "../context/userContext";

const Table = ({ data, total, handleSubscribe }) => {
  const [user] = useContext(UserContext);
  return (
    <table className="table">
      <caption style={{ captionSide: "top", paddingBottom: 0 }}>
        {total} Results
      </caption>
      <thead>
        <tr>
          <th>Code</th>
          <th>Name</th>
          <th>Type</th>
          <th>Function</th>
          <th>In Use</th>
          <th>Last Updated</th>
          <th />
          <th />
        </tr>
      </thead>
      <tbody>
        {data.map((parameter) => (
          <tr key={parameter.CODE}>
            <td className="text-nowrap">
              <Link to={`/parameters/${parameter.CODE}`}>{parameter.CODE}</Link>
            </td>
            <td>{parameter.NAME}</td>
            <td>{parameter.TYPE}</td>
            <td>{parameter.STANDARD_FUNCTION}</td>
            <td>
              {parameter.IN_USE ? (
                <span className="badge badge-success">True</span>
              ) : (
                <span className="badge badge-warning">False</span>
              )}
            </td>
            <td>{moment(parameter.LAST_UPDATED_DTS).calendar()}</td>
            <td>
              <Link to={`/parameter/${user.SITE}/${parameter.CODE}`}>
                <button className="btn btn-sm btn-outline-info">
                  View Data
                </button>
              </Link>
            </td>
            <td>
              {parameter.PTYP_CODE === "REA" && parameter.IN_USE ? (
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => handleSubscribe(parameter)}
                >
                  <i className="far fa-bell"></i> Subscribe
                </button>
              ) : null}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
